var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"sidebar-nav col--2"},[_c('ul',{staticClass:"sidebar-nav__list"},_vm._l((_vm.links),function(ref){
var to = ref.to;
var label = ref.label;
return _c('li',{key:to,staticClass:"sidebar-nav__item"},[_c('RouterLink',{staticClass:"sidebar-nav__item-link",attrs:{"to":to,"active-class":"sidebar-nav__item-link--active"},domProps:{"textContent":_vm._s(label)}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }